import { render, staticRenderFns } from "./CargoQuoteRefSummary.vue?vue&type=template&id=f4441ca4&"
import script from "./CargoQuoteRefSummary.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteRefSummary.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteRefSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteRefSummary.vue"
export default component.exports